module.exports = __webpack_public_path__ + "static/media/estimote-uwb-sample-app.9e0731f5.png";